/**
 * FullScreenSpinner — centered loading indicator for route transitions.
 */
import React from "react";

export default function FullScreenSpinner(): React.ReactElement {
  return (
    <div
      data-testid="full-screen-spinner"
      role="status"
      aria-label="Loading"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <span>Loading...</span>
    </div>
  );
}
